module.exports = __webpack_public_path__ + "static/img/C (29).13a2e0c3.png";